module.exports = __webpack_public_path__ + "static/img/logo.841ffd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo.png
// module id = Vpqn
// module chunks = 0